/* Homepage Your Dashboard: slim vertical shell (narrow column beside carousel on md+). */
'use client'

import type { ReactNode } from 'react'

import { styled } from 'styled-components'

import { FormattedMessage } from '@b-stock/fe-core/bstock-react'
import { Colors, Shadows, Typography } from '@b-stock/fe-core/design-system'

const Outer = styled.div`
  width: 100%;
  /* Match Section top padding; aligns title row. */
  padding: 3rem 0 0;
`

const Section = styled.section`
  ${Shadows.Bottom}
  border-radius: 1rem;
  padding: 1.25rem;
  background: ${Colors.Semantic.Neutral.white};
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

const Title = styled.h2`
  ${Typography.Title2}
  margin: 0;
`

const Divider = styled.hr`
  border: none;
  height: 0.0625rem;
  margin: 0;
  background: ${Colors.Semantic.Neutral.medium_grey};
`

const ModulesStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: stretch;
`

type YourDashboardProps = {
  children: ReactNode
}

/**
 * Non-collapsible shell for homepage dashboard modules. Title is “Your Dashboard” via i18n.
 */
export function YourDashboard({ children }: YourDashboardProps) {
  const titleId = 'your-dashboard-title'

  return (
    <Outer>
      <Section aria-labelledby={titleId} data-testid="your-dashboard">
        <Title id={titleId}>
          <FormattedMessage id="Search.dashboard.title" />
        </Title>
        <Divider />
        <ModulesStack>{children}</ModulesStack>
      </Section>
    </Outer>
  )
}
